export default __webpack_public_path__ + "static/media/raghad.515cd110.png";